import React from 'react';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { setShowResetButtons, setShowFitAssistant } from '../../Slices/FitAssistantSlice.ts';
import { trackClose, trackFit, trackFitNoRacks, trackNoFit } from '../../Analytics/Adobe.ts';
import {
  CarInformationSelector,
  CurrentStepSelector,
  FitStatusSelector,
  InitialDataSelector,
  ShowFitAssistantSelector,
} from '../../Selectors/FitAssistantSelectors';
import FitAssistantStep from '../../Enums/FitAssistantStep.ts';
import FitAssistantStatus from '../../Enums/FitAssistantStatus.ts';
import FitAssistantVariation from '../../Enums/FitAssistantVariation.ts';

import './ModalBackdrop.less';

const ModalBackdrop = () => {
  const dispatch = useAppDispatch();
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStep = useAppSelector(CurrentStepSelector);
  const fitStatus = useAppSelector(FitStatusSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const showFitAssistant = useAppSelector(ShowFitAssistantSelector);

  const onClose = () => {
    if (
      currentStep === FitAssistantStep.RoofRacks &&
      initialData.FitAssistantVariation === FitAssistantVariation.RooftopTents
    ) {
      trackClose(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation, 'X');
    } else if (fitStatus === FitAssistantStatus.Confirmed) {
      trackFit(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation, 'Outside');
    } else if (fitStatus === FitAssistantStatus.ConfirmedNoRacks) {
      trackFitNoRacks(
        initialData.FitAssistantVariation,
        currentStep,
        initialData.IsYearFirst,
        carInformation,
        'Outside'
      );
    } else if (fitStatus === FitAssistantStatus.NoFit) {
      trackNoFit(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation, 'Outside');
    } else {
      trackClose(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation, 'Outside');
    }

    dispatch(setShowFitAssistant(false));

    if (
      fitStatus === FitAssistantStatus.Confirmed ||
      currentStep === FitAssistantStep.NoFits ||
      currentStep === FitAssistantStep.OtherFits
    )
      dispatch(setShowResetButtons(true));
  };

  return (
    <>
      <div
        className={`fit-assistant-modal-left-slide-in-backdrop ${showFitAssistant ? 'active' : ''}`}
        onClick={onClose}
      ></div>
    </>
  );
};

export default ModalBackdrop;
